export default __webpack_public_path__ + "static/837-616b86dd28d56c57c9418d92b67fd945.gif";